import { useEffect } from "react";
import { sessionManager } from "@/broadcastChannel/sessionManager";

export default function ImpersonationHandler() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("impersonation");

    if (!token) return;

    params.delete("impersonation");
    const targetPath = `${window.location.pathname}${
      params.toString() ? `?${params.toString()}` : ""
    }`;

    // 1️⃣ On nettoie TOUT avant
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("user");
    localStorage.setItem("isImpersonating", "true");

    // 2️⃣ On injecte COMME un vrai login
    sessionManager.login({
      jwtToken: token,
      refreshToken: "admin-impersonation",
      remember: true,
    });

    // 3️⃣ On recharge l'app avec le token déjà stocké pour éviter
    // la course entre l'hydratation auth et les guards de routes.
    window.location.replace(targetPath || "/dashboard");
  }, []);

  return null;
}
